import { useState, type ComponentProps } from 'react';
import { TextInput } from '@primer/react';
import { Eye, EyeOff } from 'lucide-react';

/** A shared, accessible reveal control for every password entry point. */
export function PasswordInput(
  props: Omit<ComponentProps<typeof TextInput>, 'type' | 'trailingAction'>,
) {
  const [visible, setVisible] = useState(false);
  return (
    <TextInput
      {...props}
      type={visible ? 'text' : 'password'}
      trailingAction={
        <TextInput.Action
          aria-label={visible ? 'Hide password' : 'Show password'}
          aria-pressed={visible}
          onClick={() => setVisible(!visible)}
          icon={() => (visible ? <EyeOff size={14} /> : <Eye size={14} />)}
        />
      }
    />
  );
}
